<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'coachList' }">{{$t('entities.teamManager.plural')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('table.history')}}</el-breadcrumb-item>    </el-breadcrumb>

    <h2 class="page-title">{{$t('entities.teamManager.plural')}} history </h2>


    <div v-loading="loading">
      <el-table
        :data="list"
        empty-text="There is no history yet"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="modified"
          label="Updated at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.modified | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Updated by"
          prop="modifiedBy.email"
        ></el-table-column>

        <el-table-column
          prop="name"
          label="Name"
        ></el-table-column>

        <el-table-column
          prop="lastName"
          label="LastName"
        ></el-table-column>

        <el-table-column
          prop="dni"
          label="DNI/NIE/PASAPORTE"
        ></el-table-column>

        <el-table-column
          prop="email"
          label="Email"
        ></el-table-column>

        <el-table-column
          prop="created"
          label="Created at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.created | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Created by"
          prop="createdBy.email"
        ></el-table-column>

        <el-table-column
          prop="deleted"
          label="Deleted at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.deleted | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Deleted by"
          prop="deletedBy.email"
        ></el-table-column>
      </el-table>

      <el-button
        v-if="!last"
        @click="fetch()"
        type="infor"
        class="mt-3 w-100"
        icon="el-icon-fa-plus"
      >
        Load more...
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'app-team-manager-history-full',

  computed: {
    ...mapGetters({
      loading: 'entities/team-manager/historyFull/loading',
      list: 'entities/team-manager/historyFull/list',
      last: 'entities/team-manager/historyFull/last',
    }),
  },

  created() {
    this.$store.dispatch(
      'entities/team-manager/historyFull/setup'
    );
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch(
      'entities/team-manager/historyFull/clear',
    );
    next();
  },

  methods: {
    ...mapActions({
      fetch: 'entities/team-manager/historyFull/fetch',
    }),
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/team-manager/team-manager-history/team-manager-history-full/team-manager-history-full.vue?7df8435d